import './refund-modal.scss';

import { Modal } from 'antd';
import { useForm } from 'react-hook-form';

import { Button, DocumentController } from '@/components/Shared/ui';
import type { FileType } from '@/types/uploadFiles';

import useRefund from './hooks/useRefund';

interface IProps {
  isOpened: boolean;
  onClose: () => void;
}

const RefundModal: React.FC<IProps> = ({ isOpened, onClose }) => {
  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm<{ returnLetter: FileType }>({
    mode: 'all',
    delayError: 200
  });

  const { isRefundLoading, handleRefund } = useRefund({ onClose });

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      centered
      mask={{ closable: true }}
      className="refund-modal"
      title="Оформление возврата"
      open={isOpened}
      onCancel={handleClose}
      footer={null}
    >
      <form
        className="refund-modal__form"
        onSubmit={handleSubmit(handleRefund)}
      >
        <DocumentController
          control={control}
          name="returnLetter"
          title="Заявление возврата"
          uploadable
          isRequired
        />

        <div className="refund-modal__actions">
          <Button type="button" onClick={() => handleClose()}>
            Отмена
          </Button>
          <Button
            type="submit"
            variant="filled-red"
            disabled={Object.values(errors).length !== 0}
            isLoading={isRefundLoading}
          >
            Продолжить
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default RefundModal;
